import { Raycaster, Scene, Vector3 } from "three";
import { userDataHasAnyContext } from "../FeatureUtils";
import { PhysicalContexts } from "./CollisionTypes";

export const rayIntersects = (
  origin: Vector3,
  direction: Vector3,
  distance: number,
  scene: Scene,
  contexts: string[] = PhysicalContexts,
  ignoreContexts: string[] = []
): boolean => {
  const targetContexts = contexts.filter(
    (context) => !ignoreContexts.includes(context)
  );
  const rc = new Raycaster(origin, direction, 0, distance);
  const rawIntList = rc.intersectObjects(scene.children, true);
  const intList = rawIntList.filter((inter) => {
    return (
      inter.object.visible &&
      (userDataHasAnyContext(inter.object.userData, targetContexts) ||
        userDataHasAnyContext(inter.object.parent?.userData, targetContexts))
    );
  });

  return intList.length > 0;
};
